import React from 'react';
import {
  Button,
  CondensedLarge,
  Form,
  Gutter,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Textarea,
} from '@axiom/ui';
import type { CandidateReputationDetails } from '@axiom/validation';
import { CandidateReputationActions } from '@axiom/const';

import { ActionReputationApi } from '../../api/action-reputation-api';
import type { ReputationDismiss } from '../../schema/reputation-dismiss-form-schema';
import { ReputationDismissFormSchema } from '../../schema/reputation-dismiss-form-schema';

export type ReputationDetailsDismissModalProps = {
  onClose: () => void;
  onSubmit: () => Promise<void>;
  dismissData: CandidateReputationDetails;
};

export const ReputationDetailsDismissModal = ({
  onClose,
  onSubmit,
  dismissData,
}: ReputationDetailsDismissModalProps) => {
  const handleOnSubmit = async (changedData: Partial<ReputationDismiss>) => {
    await ActionReputationApi.createActionReputationDetails({
      reputationId: dismissData.id,
      body: {
        action: CandidateReputationActions.DISMISSED,
        actionNotes: null,
      },
    });

    await onSubmit();
  };

  return (
    <Form
      name="DISMISS_FORM"
      initialValues={{ dismissText: '' }}
      schema={ReputationDismissFormSchema}
      onSubmit={handleOnSubmit}
    >
      {({ fireSubmit }) => {
        return (
          <Modal name="WRITTEN_DISMISS_MODAL">
            <ModalHeader
              name="DISMISS_MODAL_HEADER"
              onClose={() => {
                onClose();
              }}
            >
              Dismiss top task without sending to talent
            </ModalHeader>
            <ModalSection>
              <Gutter bottom="16px">
                <CondensedLarge>
                  Please provide your reason for dismissing this top task
                  without sharing feedback with the talent.
                </CondensedLarge>
              </Gutter>
              <Textarea
                formatting="modern"
                name="dismissText"
                label="Additional details"
                full
              />
            </ModalSection>
            <ModalFooter>
              <Button
                pattern="primary"
                variation="outline"
                name="CANCEL_BUTTON"
                onClick={() => {
                  onClose();
                }}
              >
                Cancel
              </Button>
              <Button
                pattern="primary"
                name="DISMISS_BUTTON"
                onClick={() => {
                  void fireSubmit();
                }}
              >
                Dismiss Top Task
              </Button>
            </ModalFooter>
          </Modal>
        );
      }}
    </Form>
  );
};
